import Table from '@/components/common/Table'
import { Spin, Alert } from 'antd'
import SupportingDocumentsForClaimTabHistoryHook from './SupportingDocumentsForClaimTabHistory.hook'
import { RequestDocumentHistory } from '@/services/healthClaim/useRequestDocumentList/types'

const SupportingDocumentsForClaimTabHistory = ({
  onModalOpen,
}: {
  onModalOpen: (record: RequestDocumentHistory) => void
}) => {
  const { columns, tableData, isLoading, error } = SupportingDocumentsForClaimTabHistoryHook({
    onModalOpen,
  })

  if (error) {
    return (
      <Alert
        message="เกิดข้อผิดพลาด"
        description="ไม่สามารถโหลดข้อมูลประวัติขอเอกสารเพิ่มเติมได้"
        type="error"
        showIcon
      />
    )
  }

  return (
    <>
      <Spin spinning={isLoading}>
        <Table
          rowKey="RequestDocumentHistoryId"
          data-testid="supporting-documents-history-table"
          columns={columns}
          dataSource={tableData}
          scroll={{ x: true }}
          pagination={{
            pageSizeOptions: [10, 25, 50, 100],
            showSizeChanger: true,
            defaultCurrent: 1,
            showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total} รายการ`,
          }}
        />
      </Spin>
    </>
  )
}

export default SupportingDocumentsForClaimTabHistory
